import styled from 'styled-components';

export const ProgrammmingLanguageWrapper = styled.div`
.text-align-justify{
    text-align: justify;
}
.text-align-center{
    text-align: center;
}
.entry-title {
    font-weight: 600;
    font-size: 1.9rem;
    text-align: center;
}
p, li, th, td {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #334155;
}
`;
